import { typography } from '@/uptk/core/packages/style/index';

export const createTypography = () => ({
  fontFamily: 'var(--font-inter)',
  fontWeight: 'normal',
  fontSize: 12,
  // See https://material-ui.cpm/style/typography/#migration-to-typography-v2
  useNextVariants: true,
    ...typography
});

